import { render, staticRenderFns } from "./SalePerGroup.vue?vue&type=template&id=7f6c0129&"
import script from "./SalePerGroup.vue?vue&type=script&lang=js&"
export * from "./SalePerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports